require('angular').module('wowApp.shop')
    .directive('wowToolbar', ['BreakpointsService', 'OrderTrackerService', require('./toolbar-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/toolbar/index.js
 **/